export var housingUnit = function housingUnit(centralApi) {
  return {
    index: function index(params) {
      if (params === void 0) {
        params = null;
      }
      return centralApi.get('/housing-unit', {
        params: params
      });
    },
    putAudioCallEnabled: function putAudioCallEnabled(id, enabled) {
      return centralApi.put("/housing-unit/".concat(id), {
        audioCallingEnabled: enabled
      });
    },
    putVideoCallEnabled: function putVideoCallEnabled(id, enabled) {
      return centralApi.put("/housing-unit/".concat(id), {
        videoCallingEnabled: enabled
      });
    },
    putTextingEnabled: function putTextingEnabled(id, enabled) {
      return centralApi.put("/housing-unit/".concat(id), {
        textingEnabled: enabled
      });
    },
    putCommunicationsEnabled: function putCommunicationsEnabled(id, enabled) {
      return centralApi.put("/housing-unit/".concat(id), {
        communicationsEnabled: enabled
      });
    },
    putReferenceMaterialEnabled: function putReferenceMaterialEnabled(id, enabled) {
      return centralApi.put("/housing-unit/".concat(id), {
        referenceMaterialEnabled: enabled
      });
    },
    putGamesEnabled: function putGamesEnabled(id, enabled) {
      return centralApi.put("/housing-unit/".concat(id), {
        gamesEnabled: enabled
      });
    },
    putMusicEnabled: function putMusicEnabled(id, enabled) {
      return centralApi.put("/housing-unit/".concat(id), {
        musicEnabled: enabled
      });
    }
  };
};